import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { COMMON, USER_ATTENDANCE } from "../config/apiEndPoint";
import { GET, POST } from "config/api.config";

/** Maps `common/attendance-status` items `{ value, data, lableCss, bgColor }` to select options. */
export const normalizeAttendanceStatusOptions = (payload) => {
  const list = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.data)
      ? payload.data
      : [];

  return list
    .map((item) => {
      const value = item?.value ?? item?.id ?? item?.key ?? "";
      const label = String(
        item?.data ?? item?.label ?? item?.display ?? item?.name ?? item?.title ?? ""
      ).trim();
      if (value === "" && label === "") return null;
      if (!label) return null;
      return {
        value: String(value),
        label,
        lableCss: item?.lableCss ?? "",
        bgColor: item?.bgColor ?? null,
      };
    })
    .filter(Boolean);
};

/** GET `common/attendance-status` — attendance status dropdown options. */
export const fetchAttendanceStatusOptions = async (data = {}) => {
  try {
    const response = await GET(COMMON.ATTENDANCE_STATUS, data);
    return normalizeAttendanceStatusOptions(response?.data ?? response);
  } catch (error) {
    toast.error(error?.message);
    return [];
  }
};

/** GET `user/Attendance/metadata` — table columns + filter schema. */
export const fetchAttendanceMetadata = async (data = {}) => {
  try {
    const response = await GET(USER_ATTENDANCE.METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `user/Attendance/filter` — paginated attendance list. */
export const submitAttendanceFilterData = async (data = {}) => {
  try {
    const response = await POST(USER_ATTENDANCE.FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `user/Attendance/reset` — body: `{ sessionIds: string[] }`. */
export const resetAttendanceRecords = async (sessionIds = []) => {
  try {
    const response = await POST(USER_ATTENDANCE.RESET, {
      sessionIds: (Array.isArray(sessionIds) ? sessionIds : [])
        .map((id) => String(id ?? "").trim())
        .filter(Boolean),
    });
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
